import type { DataTableColumnDef } from 'components/data-table';

import type { PerforationRow } from 'types/well-perforations';

// The per-interval columns. Since INS-11031 these render ONLY in the expanded sub-table under a
// completion (see perforations.tsx), which disables sorting wholesale and pre-sorts by Top Depth MD
// ascending — so the per-column `enableSorting: false` flags below are inert, and the `id`s that
// snake_case onto the backend's gold columns (e.g. `topDepth` -> `top_depth`) no longer address
// anything on the wire: the table fetches every page and sorts client-side, so no sort param is
// sent. Both are kept as-is rather than churned, but neither is load-bearing today. `accessorKey`
// remains the display key the API emits, and that IS load-bearing.
export const perforationsColumns: DataTableColumnDef<PerforationRow>[] = [
  {
    id: 'perfDate',
    accessorKey: 'perfDate',
    header: 'Perf Date',
    size: 130,
    meta: { type: 'date' },
  },
  {
    id: 'completionObsNo',
    accessorKey: 'completionObsNo',
    header: 'Completion #',
    size: 140,
    meta: { type: 'integer', align: 'left' },
  },
  {
    id: 'stageNum',
    accessorKey: 'stageNum',
    header: 'Stage #',
    size: 110,
    meta: { type: 'integer', align: 'left' },
  },
  {
    id: 'perfObsNo',
    accessorKey: 'perfObsNo',
    header: 'Perf #',
    size: 100,
    meta: { type: 'integer', align: 'left' },
  },
  {
    id: 'perfMethod',
    accessorKey: 'perfMethod',
    header: 'Perf Method',
    size: 160,
    meta: { type: 'text' },
    enableSorting: false,
  },
  {
    id: 'topDepth',
    accessorKey: 'perfTopDepthFt',
    header: 'Top Depth MD (ft)',
    size: 170,
    meta: { type: 'decimal', align: 'left' },
  },
  {
    id: 'topTvdDepth',
    accessorKey: 'perfTopDepthTvdFt',
    header: 'Top Depth TVD (ft)',
    size: 170,
    meta: { type: 'decimal', align: 'left' },
  },
  {
    id: 'baseDepth',
    accessorKey: 'perfBaseDepthFt',
    header: 'Base Depth MD (ft)',
    size: 170,
    meta: { type: 'decimal', align: 'left' },
  },
  {
    id: 'baseTvdDepth',
    accessorKey: 'perfBaseDepthTvdFt',
    header: 'Base Depth TVD (ft)',
    size: 180,
    meta: { type: 'decimal', align: 'left' },
  },
  {
    id: 'clustersPerStage',
    accessorKey: 'clustersPerStage',
    header: 'Clusters / Stage',
    size: 150,
    meta: { type: 'integer', align: 'left' },
    enableSorting: false,
  },
  {
    id: 'perfType',
    accessorKey: 'perfType',
    header: 'Perf Type',
    size: 140,
    meta: { type: 'text' },
    enableSorting: false,
  },
  {
    id: 'perfCount',
    accessorKey: 'perfCount',
    header: 'Perf Count',
    size: 130,
    meta: { type: 'integer', align: 'left' },
    enableSorting: false,
  },
  {
    id: 'perfDensity',
    accessorKey: 'perfDensity',
    header: 'Perf Density (spf)',
    size: 170,
    meta: { type: 'decimal', align: 'left' },
    enableSorting: false,
  },
  {
    id: 'perfDiameterIn',
    accessorKey: 'perfDiameterIn',
    header: 'Perf Diameter (in)',
    size: 170,
    meta: { type: 'decimal', align: 'left' },
    enableSorting: false,
  },
  {
    id: 'perfAngleDeg',
    accessorKey: 'perfAngleDeg',
    header: 'Perf Angle (deg)',
    size: 160,
    meta: { type: 'decimal', align: 'left' },
    enableSorting: false,
  },
  {
    id: 'perfPhase',
    accessorKey: 'perfPhase',
    header: 'Perf Phase',
    size: 130,
    meta: { type: 'text' },
    enableSorting: false,
  },
  {
    id: 'perfIntervalType',
    accessorKey: 'perfIntervalType',
    header: 'Interval Type',
    size: 150,
    meta: { type: 'text' },
    enableSorting: false,
  },
  {
    id: 'chargeType',
    accessorKey: 'chargeType',
    header: 'Charge Type',
    size: 150,
    meta: { type: 'text' },
    enableSorting: false,
  },
  {
    id: 'chargeSizeGram',
    accessorKey: 'chargeSizeGram',
    header: 'Charge Size (g)',
    size: 150,
    meta: { type: 'decimal', align: 'left' },
    enableSorting: false,
  },
  {
    id: 'perfCompany',
    accessorKey: 'perfCompany',
    header: 'Perf Company',
    size: 170,
    meta: { type: 'text' },
    enableSorting: false,
  },
  {
    id: 'dataSource',
    accessorKey: 'dataSource',
    header: 'Data Source',
    size: 150,
    meta: { type: 'text' },
    enableSorting: false,
  },
  {
    id: 'updatedDate',
    accessorKey: 'updatedAt',
    header: 'Updated',
    size: 150,
    meta: { type: 'date' },
  },
];
